
import React from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

interface InputLabelProps {
  label: string;
  isFocused: boolean;
  labelClassName?: string;
}

const InputLabel: React.FC<InputLabelProps> = ({
  label,
  isFocused,
  labelClassName = ""
}) => {
  return (
    <motion.div
      initial={{ opacity: 0.9, y: 0 }}
      animate={{ 
        opacity: isFocused ? 1 : 0.9,
        y: isFocused ? -2 : 0,
        transition: { duration: 0.2 }
      }}
    >
      <Label className={cn(
        "transition-all duration-300",
        isFocused ? "text-primary font-medium" : "",
        labelClassName
      )}>
        {label}
      </Label>
    </motion.div>
  );
};

export default InputLabel;
